import { useMutation } from "@tanstack/react-query";

export const getBookings = async () => {
  const response = await fetch('/api/bookings/all');
  if (!response.ok) {
    throw new Error('Failed to fetch bookings');
  }
  return response.json();
};

export const getBookingById = async (id: string) => {
  const response = await fetch(`/api/bookings/${id}`);
  if (!response.ok) {
    throw new Error('Failed to fetch booking');
  }
  return response.json();
};

export const cancelBookingApi = async (bookingId: string) => {
  const response = await fetch(`/api/bookings/${bookingId}`, {
    method: "DELETE",
  });

  if (!response.ok) {
    throw new Error("Failed to cancel booking");
  }

  return response.json();
};

export const rescheduleBookingApi = async ({ bookingId, newDate, newStartTime, duration }: { bookingId: string | number; newDate: string; newStartTime: string; duration: 60 | 90 }) => {
  console.log("Sending booking reschedule request:", { bookingId, newDate, newStartTime, duration });

  try {
    const response = await fetch(`/api/bookings/${bookingId}/reschedule`, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ newDate, newStartTime, duration }),
    });

    console.log("Response status:", response.status);

    if (!response.ok) {
      const errorText = await response.text();
      console.error("Error response:", errorText);
      throw new Error(errorText || "Failed to reschedule booking");
    }

    const data = await response.json();
    console.log("Reschedule successful, server response:", data);
    return data;
  } catch (error) {
    console.error("Reschedule booking error:", error);
    throw error;
  }
};